import { render, staticRenderFns } from "./EditCustomerModal.vue?vue&type=template&id=363a1430&"
import script from "./EditCustomerModal.vue?vue&type=script&lang=ts&"
export * from "./EditCustomerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports